import React, { createRef, useEffect, useRef, useState } from "react";
import CustomSearchBar from "../../../../components/CustomSearchBar/CustomSearchBar";
import { Form, Formik } from "formik";
import close from "../../../../images/icons/close.png";
import add from "../../../../images/icons/add.png";
import * as Yup from "yup";
import FileUpload from "../../../../components/FileUpload/FileUpload";
import CustomInput from "../../../../components/CustomInput/CustomInput";
import edit from "../../../../images/icons/edit.png";
import delete_icon from "../../../../images/icons/delete.png";
import Table from "../../../../components/Table/Table";
import { Box } from "@material-ui/core";
import apiUtil from "../../../../api/apiUtil";
import CustomButton from "../../../../components/CustomButton/custombutton";
import "./SubCategory.css";
import CustomSelect from "../../../../components/CustomSelect/CustomSelect";
import api from "../../../../api/api";
import menu_image from "../../../../images/icons/menu.png";
import getToken from "../../../getToken";

const SubCategory = () => {
  const [showAddSubCategories, setShowAddSubCategories] = useState(false);
  const [showEditSubCategories, setShowEditSubCategories] = useState(false);
  const [menuCategoryDataList, setMenuCategoryDataList] = useState([]);
  const refSubCategoryForm = useRef(null);
  const refPreviewSubCategoryFiles = useRef(false);
  const refSelectCategory = useRef();
  const subCategoriesId = useRef(0);
  const [keyword, setKeyword] = useState("");
  let orgLevel = localStorage.getItem("orgLevel");
  const clickAddSubCategories = (e) => {
    e.stopPropagation();
    if (showEditSubCategories) {
      setShowEditSubCategories(false);
      setTimeout(() => setShowAddSubCategories(true), 100);
    } else {
      setShowAddSubCategories(true);
    }
    bindAPIMenuCategoryList();
    setSubCategoryDetail({});
  };

  const clickBtnClose = () => {
    setShowAddSubCategories(false);
    setShowEditSubCategories(false);
  };

  const subCategoryMap = {
    1: "Room Type",
    2: "Service Type",
    3: "Sub Category",
  };
  const subCategoryName = subCategoryMap[orgLevel] || "";

  const productMap = {
    1: "Room List",
    2: "Service List",
    3: "Menu List",
  };
  const productName = productMap[orgLevel] || "";

  const labelMap = {
    1: "Room",
    2: "Service",
    3: "Category",
  };
  const label = labelMap[orgLevel] || "";

  const addButtonLabels = {
    1: "Add Room Type",
    2: "Add Service Type",
    3: "Add Sub Category",
  };
  const addButtonLabel = addButtonLabels[orgLevel] || "";

  const placeholderMap = {
    1: "Select Room",
    2: "Select Service",
    3: "Select Category",
  };
  const placeholder = placeholderMap[orgLevel] || "";

  const clickDeleteSubCategory = (rowData) => {
    console.log(rowData);
    if (window.confirm("Are you sure you want to delete this item?")) {
      api
        .post(
          `Admin/DeleteSubCategory?SubCategoryId=${rowData.id}`,
          {},
          getToken()
        )
        .then((result) => {
          apiUtil.parseResult(
            result,
            (response) => {
              if (response.data.statusCode === 401) {
                alert(response.data.message);
                localStorage.removeItem("user");
                window.location.href = "/login";
              } else if (response.data.value.code == 404) {
                alert(
                  `Cannot delete ${subCategoryName} with existing ${productName}.`
                );
              } else if (response.data.statusCode === 200) {
                alert(`${subCategoryName} successfully deleted.`);
                retrieveSubCategoryList();
                console.log(response.data);
              } else {
                alert(response.data.message);
              }
            },
            (error, type) => {
              alert(error);
            }
          );
        });
    }
  };

  let AddSubCategoriesValidation = Yup.object().shape({
    name: Yup.string().required("Please enter the name."),
    image: Yup.mixed().required("Please choose the image."),
    description: Yup.string().required("Please enter the description."),
    categoryId: Yup.string().required("Please select the category."),
  });

  // sub category table
  const [subCategoryData, setSubCategoryData] = useState({
    isLoading: false,
    grouping: false,
    limit: apiUtil.getDefaultPageSize(),
    data: [],
    total: 0,
    page: 1,
  });

  const refSubCategoriesTable = createRef();
  const [paramSubCategory, setParamSubCategory] = useState({
    keyword: "",
    rowLimit: 10,
    currentPage: 1,
  });

  const retrieveSubCategoryList = (value = paramSubCategory) => {
    value.keyword = keyword || "";
    setSubCategoryData({
      ...subCategoryData,
      isLoading: true,
    });
    api
      .post("Admin/GetAllSubCategoryList", value, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              setSubCategoryData({
                isLoading: false,
                limit: response.data.data.rowLimit,
                data:
                  response.data.data.data &&
                  response.data.data.data.length > 0
                    ? response.data.data.data
                    : [],
                total: response.data.data.totalRecords,
                page: response.data.data.paging,
              });
            } else {
              setSubCategoryData({
                isLoading: false,
                grouping: false,
                limit: 0,
                data: [],
                total: 0,
                page: 0,
              });
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });
  };
  let brandId = localStorage.getItem("brandId");
  const bindAPIMenuCategoryList = () => {
    api
      .post(
        "Admin/GetCategoryListByAdmin",
        {
          rowLimit: 10,
          currentPage: 1,
          brandId: brandId,
        },
        getToken()
      )
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              if (response.data.data != null) {
                setMenuCategoryDataList(response.data.data.data);
              }
            } else {
              setMenuCategoryDataList({
                isLoading: false,
                grouping: false,
                limit: 0,
                data: [],
                total: 0,
                page: 0,
              });
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });
  };

  const menuCategorySelectList = () => {
    return menuCategoryDataList.map((mc) => ({
      label: mc.name,
      value: mc.id,
    }));
  };

  const handleSubCategoriesSubmit = (values, actions) => {
    values.image = values.image.replace(/^data:(.*,)?/, "");

    api.post("Admin/CreateSubCategory", values, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.value.code === 200) {
            alert(`New ${subCategoryName} is saved successfully.`);

            // reset the input
            actions.resetForm();
            values = {};
            setShowAddSubCategories(false);

            refSelectCategory.current.clearValue();

            for (let i = 0; i < refSubCategoryForm.current.length - 2; i++) {
              refSubCategoryForm.current[i].value = "";
            }

            // clear preview images
            refPreviewSubCategoryFiles.current = false;

            // refresh the table
            retrieveSubCategoryList(paramSubCategory);
          } else {
            alert("Something is wrong!!");
          }
        },
        (error, type) => {
          console.log(error);
        }
      );
    });

    actions.setSubmitting(false);
  };

  const [subCategoryDetail, setSubCategoryDetail] = useState({
    name: "",
    image: "",
    description: "",
    categoryId: "",
  });

  const clickBtnEditSubCategory = (e, id) => {
    e.stopPropagation();
    clickBtnClose();
    getSubCategoryDetail(id);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  };

  const getSubCategoryDetail = (id) => {
    bindAPIMenuCategoryList();
    api
      .get("Admin/GetSubCategoryById", { subCategoryId: id }, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.value.code === 200) {
              setSubCategoryDetail({
                name: response.data.value.data.name
                  ? response.data.value.data.name
                  : "",
                description: response.data.value.data.description
                  ? response.data.value.data.description
                  : "",
                image: response.data.value.data.image
                  ? response.data.value.data.image
                  : "",
                categoryId: response.data.value.data.categoryId
                  ? response.data.value.data.categoryId
                  : "",
              });
              refPreviewSubCategoryFiles.current = true;
              setShowEditSubCategories(true);
              subCategoriesId.current = id;
            } else {
              alert(response.data.value.statusText);
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });
  };

  const editSubCategoriesSubmit = async (values, actions) => {
    const subCategory = {
      brandId: brandId,
      id: subCategoriesId.current,
      ...values,
      image: values.image.replace(/^data:(.*,)?/, ""),
    };

    api
      .post("Admin/UpdateSubCategory", subCategory, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.value.code === 200) {
              alert(`${subCategoryName} updated successfully.`);

              // reset the input
              actions.resetForm();
              values = {};
              setShowEditSubCategories(false);
              // clear preview images
              refPreviewSubCategoryFiles.current = false;

              // refresh the table
              // retrieveSubCategoryList(paramSubCategory);
              // getSubCategoryDetail(subCategoriesId.current);
            } else {
              alert(response.data.statusText);
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });

    actions.setSubmitting(false);
  };

  useEffect(() => {
    retrieveSubCategoryList();
  }, [paramSubCategory]);

  return (
    <>
      {showAddSubCategories || showEditSubCategories ? (
        <>
          <div className=" Actions space_between">
            <h6 className="title_text mt-2">{subCategoryName}</h6>
            <button className="btn btnClose" onClick={clickBtnClose}>
              <img src={close} className="imgClose" alt="imgClose" />
            </button>
          </div>
          <div className="sub-category-form">
            <Formik
              initialValues={{
                name: subCategoryDetail.name ? subCategoryDetail.name : "",
                image:
                  subCategoryDetail.image != null
                    ? subCategoryDetail.image
                    : null,
                description: subCategoryDetail.description
                  ? subCategoryDetail.description
                  : "",
                categoryId: subCategoryDetail.categoryId
                  ? subCategoryDetail.categoryId
                  : "",
              }}
              validationSchema={AddSubCategoriesValidation}
              validateOnBlur={false}
              enableReinitialize={true}
              onSubmit={(values, actions) => {
                if (showEditSubCategories) {
                  editSubCategoriesSubmit(values, actions);
                } else {
                  handleSubCategoriesSubmit(values, actions);
                }
              }}
            >
              {({ errors, touched, values, setFieldValue }) => (
                <Form
                  ref={refSubCategoryForm}
                  className="row form-container product-form"
                >
                  <div className="col-6 mt-2">
                    <CustomInput
                      name="name"
                      type="text"
                      label="Name"
                      customclass="input_wrapper"
                      hideicon="true"
                    />
                  </div>
                  <div className="col-6 mt-2">
                    <FileUpload
                      label="Image"
                      name="image"
                      handleFile={(file) => {
                        if (file.length > 0) {
                          const reader = new FileReader();
                          refPreviewSubCategoryFiles.current = true;

                          reader.onload = () => {
                            if (typeof reader.result === "string") {
                              const encoded_image = reader.result;
                              setFieldValue("image", encoded_image);
                            } else {
                              console.error(
                                "Error: FileReader result is not a string."
                              );
                            }
                          };
                          reader.readAsDataURL(file[0]);
                        }
                      }}
                      refPreviewFiles={refPreviewSubCategoryFiles}
                    />
                  </div>
                  <div className="col-6 mt-2">
                    <CustomSelect
                      options={menuCategorySelectList()}
                      name="categoryId"
                      label={label}
                      isClearable={false}
                      placeholder={placeholder}
                      refSelect={refSelectCategory}
                    />
                  </div>
                  <div className="col-12 mt-2">
                    <CustomInput
                      name="description"
                      label="Description"
                      textarea="true"
                    />
                  </div>
                  <div className="col-12 mt-3">
                    <div className="Actions justify-content-end">
                      <button
                        type="button"
                        className="button btnCancel"
                        onClick={clickBtnClose}
                      >
                        Cancel
                      </button>
                      <button type="submit" className="button btnSave">
                        {showAddSubCategories ? "Create" : "Update"}
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
          {/* </div>
          </div> */}
        </>
      ) : null}

      <div className=" Actions space_between">
        <h6 className="title_text mt-2">{subCategoryName}</h6>
        <div className="d-flex justify-content-end gap-16 align-items-center">
          {/* <CustomFilter /> */}
          <CustomSearchBar
            value={keyword}
            setValue={setKeyword}
            onSearch={() => retrieveSubCategoryList()}
          />
          {!showAddSubCategories && (
            <CustomButton
              icon={add}
              text={addButtonLabel}
              addIcon={true}
              className="btnAdd"
              onClick={(e) => clickAddSubCategories(e)}
            />
          )}
        </div>
      </div>

      <div className="table_container prdouct_table sub_category_table">
        <Table
          key={subCategoryData.total}
          ref={refSubCategoriesTable}
          maxBodyHeight={subCategoryData.limit * 50}
          isLoading={subCategoryData.isLoading}
          grouping={subCategoryData.grouping}
          limit={subCategoryData.limit}
          data={subCategoryData.data}
          total={subCategoryData.total}
          page={subCategoryData.page}
          onPageChange={(page) => {
            setParamSubCategory({
              ...paramSubCategory,
              currentPage: page,
            });

            retrieveSubCategoryList(paramSubCategory);
          }}
          columns={[
            {
              title: "No",
              render: (row) => {
                const startingIndex =
                  (subCategoryData.page - 1) * subCategoryData.limit + 1;
                return startingIndex + row.tableData.index;
              },
              width: "80px",
              align: "center",
            },
            {
              title: "Image",
              render: (row) => {
                if (row.image == null || row.image == "") {
                  row.image = menu_image;
                }
                return (
                  <img
                    src={row.image}
                    alt=""
                    className="d-block imgProduct"
                    onError={(e) => (e.target.src = menu_image)}
                  />
                );
              },
              width: "180px",
            },
            {
              title: "Name",
              render: (row) => {
                if (row.name.length > 40) {
                  return row.name.substring(0, 39) + "...";
                }
                return row.name;
              },
              width: "220px",
            },
            {
              title: "Description",
              render: (row) => {
                if (row.description.length > 40) {
                  return row.description.substring(0, 39) + "...";
                }
                return row.description;
              },
              width: "350px",
            },
            {
              title: "Edit",
              render: (row) => {
                return (
                  <Box
                    className=" cursor-pointer"
                    onClick={(e) => clickBtnEditSubCategory(e, row.id)}
                  >
                    <img src={edit} alt="" className="imgIcon" />
                  </Box>
                );
              },
              align: "center",
              sorting: false,
              width: "80px",
            },
            {
              title: "Delete",
              render: (row) => {
                return (
                  <Box
                    style={{ cursor: "pointer" }}
                    onClick={() => clickDeleteSubCategory(row)}
                  >
                    <img src={delete_icon} alt="" className="imgIcon" />
                  </Box>
                );
              },
              align: "center",
              sorting: false,
              width: "80px",
            },
          ]}
        />
      </div>
    </>
  );
};

export default SubCategory;
